{
  "datatable": {
    "rowsPerPage": "ჩანაწერი გვერდზე"
  },
  "department": {
    "addDepartment": "დეპარტამენტის დამატება",
    "createNewDepartment": "ახალი დეპარტამენტის შექმნა",
    "departmentAdmin": "დეპარტამენტის ადმინისტრატორი",
    "departmentName": "დეპარტამენტის დასახელება",
    "institution": "ორგანიზაციის დასახელება",
    "institutionName": "ორგანიზაციის დასახელება",
    "searchDepartments": "დეპარტამენტ(ებ)ის ძიება",
    "thisFieldIsRequired": "ეს ველი აუცილებელია"
  },
  "general": {
    "add": "დამატება",
    "cancel": "გაუქმება",
    "dateAdded": "თარიღი დამატებულია",
    "dateUpdated": "თარიღი განახლებულია",
    "delete": "წაშლა",
    "edit": "რედაქტირება",
    "loading": "ინვირთება ...",
    "no": "არა",
    "noData": "მონაცემები არაა",
    "ok": "Ok",
    "remove": "მოცილება",
    "save": "შენახვა",
    "selectAll": "ყველას არჩევა",
    "yes": "დიახ",
    "selectGender": "სქესის არჩევა",
    "gender": {
      "male": "მამრობითი",
      "female": "მდედრობითი"
    }
  },
  "menu": {
    "departments": "დეპარტამენტები",
    "home": "სახლი",
    "procedures": "პროცედურები",
    "scheduling": "დაგეგმვა",
    "users": "მომხმარებლები"
  },
  "procedure": {
    "allSteps": "ყველა ნაბიჯი",
    "authors": "ავტორ(ებ)ი",
    "category": "კატეგორია",
    "createNewStep": "ახალი ნაბიჯის შექმნა",
    "defineFeedback": "უკუკავშირის განსაზღვრა",
    "description": "აღწერა",
    "disableProcedure": "პროცედურის გამორთვა",
    "addProceduresInformation": "პროცედურის ინფორმაციის დამატება",
    "editProceduresInformation": "პროცედურის ინფორმაციის რედაქტირება",
    "duplicateStartEndStepWarning": "დაშვებულია მხოლოდ 1 საწყისი და 1 საბოლოო ნაბიჯი",
    "information": "ინფორმაცია",
    "language": "ენა",
    "languagesAvailable": "ხელმისაწვდომი ენები",
    "media": "მედია",
    "name": "დასახელება",
    "owner": "მფლობელი",
    "procedureCategory": "პროცედურის კატეგორია",
    "procedureLanguage": "პროცედურის ენა",
    "procedureName": "პროცედურის დასახელება",
    "procedureNotFound": "პროცედურა ვერ მოინახა",
    "public": "საერთო",
    "publicPrivate": "საერთო/პირადი",
    "revisionHistory": "ცვლილებების ისტორია",
    "searchSteps": "ნაბიჯების ძიება",
    "seeFeedback": "უკუკავშირის ნახვა",
    "statistics": "სტატისტიკა",
    "step": "ნაბიჯი",
    "thisFieldIsRequired": "ეს ველი აუცილებელია",
    "viewAs": "ნახვა როგორც"
  },
  "procedures": {
    "addProcedure": "პროცედურის დამატება",
    "category": "კატეგორია",
    "deleteProcedure": "პროცედურის წაშლა",
    "department": "დეპარტამენტი",
    "filter": "ფილტრი",
    "private": "პირადი",
    "procedures": "პროცედურები",
    "public": "საერთო",
    "publicPrivate": "საერთო/პირადი",
    "searchProcedures": "პროცედურების ძებნა",
    "sort": "სორტირება"
  },
  "step": {
    "addDescription": "აღწერის დამატება",
    "addParentStep": "ზედა ნაბიჯის დამატება",
    "chooseParentSep": "აირჩიეთ ზედა ნაბიჯი",
    "chooseStepOption": "აირჩიეთ ნაბიჯის ოპცია",
    "chooseTransitionType": "აირჩიეთ გადასვლის ტიპი",
    "chooseType": "აირჩიეთ ტიპი",
    "description": "აღწერა",
    "dropFilesOrClickToUpload": "ჩაყარეთ ფაილები აქ, ან დააჭირეთ ასატვირთად",
    "editStep": "ნაბიჯის რედაქტირება",
    "insertMaxValue": "მაქსიმალური მნიშვნელობის ჩასმა",
    "insertMinValue": "მინიმალური მნიშვნელობის ჩასმა",
    "insertOption": "ოპციის ჩასმა",
    "option": "ოპცია",
    "owner": "მფლობელი",
    "parentStep": "ზედა ნაბიჯი",
    "previousStep": "წინა ნაბიჯი",
    "saveMedia": "მედიას შენახვა",
    "stepMedia": "მედია ნაბიჯი",
    "transitionToNextStep": "შემდეგ ნაბიჯზე გადასვლა",
    "transitionType": "გადასვლის ტიპი",
    "type": "ტიპი",
    "value": "მნიშვნელობა",
    "viewInProcedure": "პროცედურაში ნახვა",
    "error": {
      "WONT_REACH_END": "დასასრულამდე გზა არ არის",
      "EXIT_NOT_IN_USE": "გამოუყენებელი გამოსასვლელი",
      "NO_PARENT_SET": "წინა ნაბიჯი არ არის",
      "PARENT_NOT_EXITS": "განსაზღვრული მშობელი ნაბიჯი არ არსებობს",
      "DUPLICATE_START": "პროცედურას შეიძლება ჰქონდეს მხოლოდ ერთი საწყისი ნაბიჯი",
      "DUPLICATE_END": "პროცედურას შეიძლება ჰქონდეს მხოლოდ ერთი დასასრული ნაბიჯი"
    }
  },
  "user": {
    "chooseUserRole": "მომხმარებლის როლის არჩევა",
    "department": "დეპარტამენტი",
    "emails": "მომხმარებლის ეფოსტ(ებ)ი",
    "emailsDescription": "ჩასვით 1 ან მეტი ელფოსტა, გამოყავით მძიმით. არჩეული მომხმარებლის როლად დარეგისტრირების მოსაწვევები მომხმარებლებს ელფოსტით გადაეგზავნებათ.",
    "institution": "ორგანიზაცია",
    "institutionalAdmin": "ორგანიზაციის ადმინისტრატორი",
    "institutionAndDepartment": "ორგანიზაცია და დეპარტამენტი",
    "inviteUsers": "მომხმარებლების მოწვევა",
    "nurse": "ექთანი",
    "patient": "პაციენტი",
    "searchUsers": "მომხმარებლ(ებ)ის ძიება",
    "subscription": "ხელმოწერა",
    "thisFieldIsRequired": "ეს ველი აუცილებელია",
    "user": "მომხმარებელი",
    "userRole": "მომხმარებლის როლი"
  },
  "approvalRequest": {
    "actionType": "Action Type",
    "requestedBy": "Requested By",
    "approvedBy": "Approved By",
    "confirms": {
      "approveTitle": "Approve request",
      "approveText": "Are you sure you want to approve this request?",
      "rejectTitle": "Reject request",
      "rejectText": "Please provide a reason for rejecting this request.",
      "rejectReasonPlaceholder": "Rejection reason"
    },
    "actionTypes": {
      "PERMISSION_GRANT": "Permission Grant",
      "PERMISSION_REVOKE": "Permission Revoke",
      "EXPORT_VISITS": "Export Visits",
      "EXPORT_LOCATION_HISTORY": "Export Location History",
      "EXPORT_ARRIVAL_HISTORY": "Export Arrival History",
      "ENABLE_USER": "Enable User",
      "DISABLE_USER": "Disable User"
    },
    "toasts": {
      "created": "Approval request created",
      "applied": "Action applied",
      "applyFailed": "Failed to apply action",
      "approved": "Request approved",
      "approveFailed": "Failed to approve request",
      "rejected": "Request rejected",
      "rejectFailed": "Failed to reject request"
    }
  }
}
